import { Box, Grid2 } from "@mui/material";
import WalletOverviewCard from "./Component/WalletOverviewCard";
import SendCoin from "./Component/SendCoin";
import ReceiveCoin from "./Component/ReceiveCoin";
import EarningGraph from "./Component/EarningGraph";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { FETCH_WALLET_TYPE } from "reduxStore/actions/authActionType";

const WalletPage = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({ type: FETCH_WALLET_TYPE });
  }, []);

  return (
    <Box sx={styles.container}>
      <Grid2 container spacing={2} mb={2}>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <WalletOverviewCard />
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <EarningGraph />
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <SendCoin />
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <ReceiveCoin />
        </Grid2>
      </Grid2>
    </Box>
  );
};
export default WalletPage;
const styles = {
  container: {
    flexGrow: 1,
  },
};
